(function () {
  'use strict';

  angular.module('wsLrs.controllers').controller('EditActivitiesCtrl', ['$http', '$scope', '$timeout', 'Alerts', 'Api', 'Interactions', 'RequestCache', 'TinCanJS', function ($http, $scope, $timeout, Alerts, Api, Interactions, RequestCache, TinCanJS) {
    var UPDATE_VERB_ID = "http://activitystrea.ms/schema/1.0/update";
    var URL_REGEX = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/;
    $scope.cfg = {
      activitySearchToggleSelect: {
        options: [{
          text: "Activity IDs and Names (default)",
          searchPlaceholder: "Search by Activity IDs and Names (default)",
          state: "include_ids",
          default: true,
          selected: true
        }, {
          text: "Activity IDs only",
          searchPlaceholder: "Search by Activity IDs only",
          state: "exclude_names",
          default: false,
          selected: false
        }, {
          text: "Activity Names only",
          searchPlaceholder: "Search by Activity Names only",
          state: "exclude_ids",
          default: false,
          selected: false
        }],
        selectedOption: {
          text: "Activity IDs and Names (default)",
          searchPlaceholder: "Search by Activity IDs and Names (default)",
          state: "include_ids",
          default: true,
          selected: true
        },
        isDefaultSelected: true,
        dropdownOpen: false
      }
    };
    $scope.$watch('cfg.activitySearchToggleSelect.selectedOption.state', function (toggleState) {
      $scope.searchToggle = toggleState;
    });
    function clearActivity() {
      $scope.selectedActivity = null;
      $scope.language = "en-US";
      $scope.languages = [];
      $scope.activityId = null;
      $scope.activityDefinition = null;
      $scope.activityDefinitionJson = {};
      $scope.rawStatements = [];
      $scope.statements = [];
      $scope.saveEnabled = true;
      $scope.errorMessage = null;
      $scope.successMessage = null;
      if ($scope.clearActivityTypeAhead) {
        $scope.clearActivityTypeAhead();
      }
      if ($scope.editor) {
        $scope.editor.setValue("{}");
      }
      $scope.activeTab = {
        simple: true
      };
    }
    function reloadInteractionStream() {
      $scope.statements = [];
      var params = {
        limit: 3,
        config: {
          filter: {
            activityIds: {
              ids: [$scope.activityId]
            },
            not: {
              verbIds: {
                ids: [UPDATE_VERB_ID]
              }
            }
          }
        }
      };
      Interactions.get(params, true).then(function (statements) {
        $scope.rawStatements = statements;
        $scope.statements = TinCanJS.getExtendedDecoratedStatements(statements);
        updateInteractionStream();
      });
    }
    function updateInteractionStream() {
      $scope.isValidType = true;
      if ($scope.activityDefinition.type && $scope.activityDefinition.type.length > 0) {
        $scope.isValidType = URL_REGEX.test($scope.activityDefinition.type);
        $scope.isValidType = $scope.isValidType && !_.contains(["=", "+", "-", "@"], $scope.activityDefinition.type.charAt(0));
      }
      $scope.isValidName = true;
      if ($scope.activityDefinition.name[$scope.language]) {
        var name = $scope.activityDefinition.name[$scope.language];
        $scope.isValidName = name.length > 0 && !_.contains(["=", "+", "-", "@"], name.charAt(0));
      }
      $scope.saveEnabled = $scope.isValidType && $scope.isValidName;
      if ($scope.isValidType && $scope.isValidName) {
        _.each($scope.rawStatements, function (stmt) {
          stmt.object.definition = $scope.activityDefinition;
        });
        $scope.statements = TinCanJS.getExtendedDecoratedStatements($scope.rawStatements);
      }
    }
    function updateLanguages(actDef) {
      var lang = null,
        languages = {};
      $scope.language = "en-US";
      if (actDef.name) {
        for (lang in actDef.name) {
          if (actDef.name.hasOwnProperty(lang)) {
            languages[lang] = lang;
          }
        }
      }
      if (actDef.description) {
        for (lang in actDef.description) {
          if (actDef.description.hasOwnProperty(lang)) {
            languages[lang] = lang;
          }
        }
      }
      $scope.languages = [];
      for (lang in languages) {
        if (languages.hasOwnProperty(lang)) {
          $scope.languages.push(lang);
        }
      }
      if (!languages['en-US'] && !languages['en-us']) {
        for (lang in languages) {
          if (languages.hasOwnProperty(lang)) {
            $scope.language = lang;
            break;
          }
        }
      }
    }
    function loadSelectedActivity() {
      var cfg = {
        params: {
          activityId: $scope.selectedActivity.activityId
        },
        headers: {
          "X-Experience-API-Version": "1.0.0",
          "Authorization": "Cookie wsAuth"
        }
      };

      // This is fetching the activity definition straight from the LRS
      $http.get(Api.url('/lrs/activities'), cfg).then(function (response) {
        var activity = response.data;
        $scope.activityId = activity.id;
        $scope.activityDefinition = activity.definition || {};
        updateLanguages($scope.activityDefinition);
        reloadInteractionStream();
      }, function () {
        $scope.error = "Uh oh, there was an error loading the activity.";
      });
    }
    function saveActivityDefinition() {
      // Safety check, button is disabled, but in case manually enabled.
      if (!$scope.isValidName || !$scope.isValidType) {
        return;
      }
      var actToSave = {
        id: $scope.activityId,
        definition: angular.copy($scope.activityDefinition)
      };
      actToSave.definition.extensions = _.extend({}, actToSave.definition.extensions, {
        "http://watershedlrs.com/xapi/extensions/edit-date": new Date().toISOString()
      });

      // Save the activity by issuing a statement to the LRS with the updated definition
      TinCanJS.sendStatement({
        verb: {
          "id": UPDATE_VERB_ID,
          "display": {
            "en-US": "updated"
          }
        },
        object: actToSave
      }).then(function () {
        var actDef = $scope.activityDefinition;
        var success = {
          message: "Activity updated successfully.  Allow up to 30 minutes for this change to be reflected in your reports.",
          activity: {
            activityId: $scope.activityId,
            name: actDef && actDef.name && actDef.name[$scope.language]
          }
        };
        $scope.clearActivity();
        $scope.success = success;
        loadRecentActivities(success.activity);
        RequestCache.clear();
      }, function () {
        $scope.errorMessage = "Uh oh, there was an error saving this activity.";
      });
    }
    function loadRecentActivities(editedActivity) {
      var params = {
        _limit: 10,
        order_by: "-editDate"
      };
      $http.get(Api.url("/acc/activities"), {
        params: params
      }).then(function (response) {
        // Filter out results that don't have any edit date
        $scope.recentActivities = _.reject(response.data.results, function (activity) {
          return !activity.editDate;
        });

        // This ensures that the UI will show the most recent name as it was edited
        // by the user, even if the async part of renaming is still running
        if (editedActivity) {
          $scope.recentActivities = _.reject($scope.recentActivities, function (activity) {
            return activity.activityId === editedActivity.activityId;
          });
          $scope.recentActivities.unshift(editedActivity);
        }
      }, function () {
        $scope.recentActivities = [];
      });
    }

    // Basically, event handler for change of selected activity from the
    // activity type-ahead directive.
    $scope.$watch("selectedActivity", function (newValue) {
      if (newValue) {
        $scope.success = null;
        loadSelectedActivity();
        $scope.clearActivityTypeAhead();
      }
    });

    // Handle switching of tabs between simple and advanced
    $scope.tabSwitch = function (tabName) {
      $scope.activeTab = {};
      $scope.activeTab[tabName] = true;
      if ("simple" === tabName) {
        updateLanguages($scope.activityDefinition);
      } else if ("advanced" === tabName) {
        $scope.editor.setValue(angular.toJson($scope.activityDefinition, 2), -1);
      }
    };

    // Dropdown click interaction, selects language to edit in simple mode
    $scope.selectLanguage = function (lang) {
      $scope.language = lang;
    };

    // On-change handler for editing, just updates the interaction stream text
    // in place.
    $scope.updateInteractionStream = _.debounce($scope.$safeApply.bind($scope, updateInteractionStream), 500);

    // -------------------------------
    // Advanced Editor (ACE)
    // -------------------------------

    $scope.aceLoaded = function (_editor) {
      $scope.editor = _editor;
      var session = _editor.getSession();
      session.setMode("ace/mode/json");
      session.setTabSize(2);
      session.setUseSoftTabs(true);
    };
    $scope.aceChanged = _.debounce($scope.$safeApply.bind($scope, function () {
      try {
        $scope.activityDefinition = JSON.parse($scope.editor.getValue());
        $scope.saveEnabled = true;
        updateInteractionStream();
      } catch (error) {
        if (error.name === 'SyntaxError') {
          $scope.saveEnabled = false;
          return;
        }
        throw error;
      }
    }), 500);

    // For edit button on recent activity list, just hook into selectedActivity
    $scope.editActivity = function (activity) {
      $scope.selectedActivity = activity;
    };

    // Save the activity definition
    $scope.save = saveActivityDefinition;

    // Bind clearActivity to scope so we can call from cancel button
    $scope.clearActivity = clearActivity;

    // Init by clearing editing state and loading recent activities
    clearActivity();
    loadRecentActivities();
  }]);
})();
